import { GetApiData } from "utils/http-client";

export const getUserInfo = async () => {
    return await GetApiData(`/user`, 'GET', null, true);
};
export const getStudentInfo = async (id) => {
    return await GetApiData(`/user/student/${id}`, 'GET', null, true);
};
export const getTeacherInfo = async (id) => {
    return await GetApiData(`/user/teacher/${id}`, 'GET', null, true);
};
export const getStudentStats = async () => {
    return await GetApiData(`/submission/student/stats`, 'GET', null, true);
};
export const getStudentStatsById = async (id) => {
    return await GetApiData(`/submission/student/stats/${id}`, 'GET', null, true);
};
export const getClassStats = async () => {
    return await GetApiData(`/submission/class/stats`, 'GET', null, true);
};
export const getTeacherStats = async () => {
    return await GetApiData(`/submission/teacher/stats`, 'GET', null, true);
};
export const getUpcomingAssignments = async (type="", selectedClass="", subject="") => {
    return await GetApiData(`/assignment/upcoming?exerciseType=${type}&selectedClass=${selectedClass}&subject=${subject}`, 'GET', null, true);
};

export const getClassDetail = async () => {
    return await GetApiData(`/class/me`, 'GET', null, true);
};

export const getGroupOrClassDetail = async (id) => {
    return await GetApiData(`/class/${id}`, 'GET', null, true);
};